import React from "react";

import PageContents from "components/PageContents";
import { Typography } from "@mui/material";

export default function LoginForgotPage() {


    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined);

    const buttonRef = React.useRef<HTMLButtonElement | null | undefined>();


    function onSubmit(evt: React.FormEvent<HTMLFormElement>) {

        evt.preventDefault();

        setErrorMessage(undefined);

        let login = document.getElementById("login") as HTMLInputElement
        let loginValue = login.value.trim();
        if (loginValue === '') {
            //console.log("There is no email")
            return alert('Login/Email is empty!');
        }


        let password = document.getElementById("password") as HTMLInputElement
        let passwordValue = password.value.trim()
        if (passwordValue === '') {
            return alert('Password is empty!');
        }
        return;
    };


    // let input = document.getElementById('email') ;
    // let value = input.value.trim();

    // if (value === '') {
    //     alert('There is no email');
    //     return;
    // }
    // if (!validateEmail(value)) {
    //     alert('Incorrect email');
    //     return;
    // }

    // TODO: just PageFormDialog
    return <PageContents title='Forgot Login'>
        <Typography>Under construction</Typography>
        {/* <Page.PageDialogContents>
        <Page.ForgotPageDialog>
        <Form.InputForm onSubmit={(evt) => onSubmit(evt)} >

            <Form.Title title='Recover Login' > Recover Login
                <Form.TableInputField placeholder='Login / Email / Phone Number' id='login' name='Login / Email / Phone Number'  />


                <Form.SubmitButton ref={buttonRef}>Send Request</Form.SubmitButton>


            </Form.Title>

            </Form.InputForm>

            </Page.ForgotPageDialog>

        </Page.PageDialogContents> */}

    </PageContents>;
}

